<template>
    <b-col 
        class="sag-datepicker mb-1"
        sm="12"
    >
        <label :id="'lab_' + id" :for="id">{{ label }}</label>
        <b-row>
            <b-col>
                <b-input-group>
                    
                    <b-form-input
                        type="date"
                        :id="'dt_' + id"
                        v-model="refSagDate"
                        v-bind="$attrs"
                    >

                    </b-form-input>
                </b-input-group>
            </b-col>
            <b-col>
                <b-input-group>
                    <b-form-input
                        type="time"
                        :id="'tm_' + id"
                        v-model="refSagTime"
                        v-bind="$attrs"
                    >

                    </b-form-input>
                </b-input-group>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { BRow, BCol, BFormDatepicker, BFormTimepicker, BInputGroupAppend, BFormInput, BInputGroup } from 'bootstrap-vue'
import tools from '@/sag-core/tools'
export default {
    components: {
        BFormDatepicker,
        BFormTimepicker,
        BInputGroupAppend,
        BFormInput,
        BInputGroup,
        BRow,
        BCol
    },
    props: {
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        sagValue: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }){
        const dateTimeParse = tools.dateTimeParse
        const dateTimeFormat = tools.dateTimeFormat

        const lock = ref(false)

        const refSagDate = ref(dateTimeFormat(dateTimeParse(props.sagValue).split(' ')[0] || '', '-'))
        const refSagTime = ref(dateTimeParse(props.sagValue).split(' ')[1] || '')
        watch([refSagDate, refSagTime], ([newDate, newTime], [oldDate, oldTime])=>{
            
            
            
            if(!lock.value){
                if(newDate != oldDate){
                    emit('sagChangeEvent', {
                        name: props.id,
                        value: dateTimeFormat(refSagDate.value + ' ' + refSagTime.value, '/')
                    })
                }
                else if(newTime != oldTime){
                    emit('sagChangeEvent', {
                        name: props.id,
                        value: dateTimeFormat(refSagDate.value + ' ' + refSagTime.value, '/')
                    })                
                }
            }
        })

        emit('sagRefreshData', {
            key: props.id,
            value: (newValue)=>{
                lock.value = false
                refSagDate.value = dateTimeFormat(dateTimeParse(newValue).split(' ')[0] || '', '-')
                refSagTime.value = dateTimeParse(newValue).split(' ')[1] || ''
            }
        })

        emit('sagInputData', (sagValue)=>{
            lock.value = true
            refSagDate.value = dateTimeFormat(dateTimeParse(sagValue).split(' ')[0] || '', '-')
            refSagTime.value = dateTimeParse(sagValue).split(' ')[1] || ''
        })

        return {
            refSagDate,
            refSagTime
        }

    }
}
</script>